import { createFileRoute, Link } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight, X, ArrowLeft } from "lucide-react";
import hero4 from "@/assets/rendering-hero-4.jpg.asset.json";
import nightHero from "@/assets/rendering-night-hero.jpg.asset.json";
import phCrown from "@/assets/rendering-ph-crown-1.jpg.asset.json";
import phPool from "@/assets/rendering-ph-pool-3.jpg.asset.json";
import pool1 from "@/assets/rendering-pool-1.jpg.asset.json";
import terrace from "@/assets/rendering-terrace.jpg.asset.json";
import upwardHero from "@/assets/rendering-upward-hero.jpg.asset.json";
import arrival from "@/assets/rendering-arrival.jpg.asset.json";
import wineRoom from "@/assets/rendering-wine-room.jpg.asset.json";
import hammam from "@/assets/rendering-hammam.jpg.asset.json";
import wetRoom from "@/assets/rendering-wet-room.jpg.asset.json";
import tub from "@/assets/rendering-tub.jpg.asset.json";
import stArrival from "@/assets/rendering-south-tower-arrival.jpg.asset.json";
import stLobby from "@/assets/rendering-south-tower-lobby.jpg.asset.json";
import teaPavillion from "@/assets/rendering-tea-pavillion.jpg.asset.json";
import primaryCloset from "@/assets/rendering-primary-closet.jpg.asset.json";
import terraceSunrise from "@/assets/rendering-terrace-sunrise.jpg.asset.json";
import terraceDusk from "@/assets/rendering-terrace-dusk.jpg.asset.json";
import terraceCol3U2 from "@/assets/rendering-terrace-col3-u2.jpg.asset.json";
import terraceCol3U3 from "@/assets/rendering-terrace-col3-u3.jpg.asset.json";
import primaryBedroom from "@/assets/rendering-primary-bedroom.jpg.asset.json";
import oceanPoolAerial from "@/assets/rendering-ocean-pool-aerial.jpg.asset.json";
import lagoonPool from "@/assets/rendering-lagoon-pool.jpg.asset.json";
import hoverCol3U3 from "@/assets/rendering-hover-col3-u3.jpg.asset.json";
import kitchenWarm from "@/assets/rendering-kitchen-warm.jpg.asset.json";
import gym from "@/assets/rendering-gym.jpg.asset.json";
import greatRoomCol4 from "@/assets/rendering-great-room-col4-u1.jpg.asset.json";
import greatRoomCol2 from "@/assets/rendering-great-room-col2-u3.jpg.asset.json";
import greatRoomCol1 from "@/assets/rendering-great-room-col1-u2.jpg.asset.json";
import diningPavilion from "@/assets/rendering-dining-pavilion.jpg.asset.json";
import courtyardNight from "@/assets/rendering-courtyard-night.jpg.asset.json";
import courtyardDay from "@/assets/rendering-courtyard-day.jpg.asset.json";
import col2U4 from "@/assets/rendering-col2-u4.jpg.asset.json";
import bathroomSauna from "@/assets/rendering-bathroom-sauna.jpg.asset.json";
import wellnessCabana from "@/assets/rendering-wellness-cabana.jpg.asset.json";
import privateDining from "@/assets/rendering-private-dining.jpg.asset.json";
import forestYoga from "@/assets/rendering-forest-yoga.jpg.asset.json";
import podium from "@/assets/rendering-podium.jpg.asset.json";
import oceanCabana from "@/assets/rendering-ocean-cabana.jpg.asset.json";


const renderings = [
  { src: hero4.url, title: "Tower Hero" },
  { src: upwardHero.url, title: "Upward Hero" },
  { src: nightHero.url, title: "Night Hero" },
  { src: arrival.url, title: "Arrival" },
  { src: stArrival.url, title: "South Tower Arrival" },
  { src: stLobby.url, title: "South Tower Lobby" },
  { src: pool1.url, title: "Pool Deck" },
  { src: oceanPoolAerial.url, title: "Ocean Pool Aerial" },
  { src: lagoonPool.url, title: "Lagoon Pool" },
  { src: oceanCabana.url, title: "Ocean Cabana" },
  { src: wellnessCabana.url, title: "Wellness Cabana" },
  { src: podium.url, title: "Podium" },
  { src: phPool.url, title: "Penthouse Pool" },
  { src: phCrown.url, title: "Penthouse Crown" },
  { src: terrace.url, title: "Residence Terrace" },
  { src: terraceSunrise.url, title: "Terrace at Sunrise" },
  { src: terraceDusk.url, title: "Terrace at Dusk" },
  { src: terraceCol3U2.url, title: "Terrace — Collection III, Unit 02" },
  { src: terraceCol3U3.url, title: "Terrace — Collection III, Unit 03" },
  { src: hoverCol3U3.url, title: "Hover — Collection III, Unit 03" },
  { src: greatRoomCol1.url, title: "Great Room — Collection I, Unit 02" },
  { src: greatRoomCol2.url, title: "Great Room — Collection II, Unit 03" },
  { src: greatRoomCol4.url, title: "Great Room — Collection IV, Unit 01" },
  { src: col2U4.url, title: "Collection II — Unit 04" },
  { src: kitchenWarm.url, title: "Kitchen — Warm Palette" },
  { src: diningPavilion.url, title: "Dining Pavilion" },
  { src: privateDining.url, title: "Private Dining" },
  { src: courtyardDay.url, title: "Courtyard by Day" },
  { src: courtyardNight.url, title: "Courtyard by Night" },
  { src: primaryBedroom.url, title: "Primary Bedroom" },
  { src: primaryCloset.url, title: "Primary Closet" },
  { src: teaPavillion.url, title: "Tea Pavillion" },
  { src: wineRoom.url, title: "Wine Room" },
  { src: gym.url, title: "Gym" },
  { src: forestYoga.url, title: "Forest Yoga" },
  { src: hammam.url, title: "Hammam" },
  { src: bathroomSauna.url, title: "Bathroom Sauna" },
  { src: wetRoom.url, title: "Wet Room" },
  { src: tub.url, title: "Tub" },
];

export const Route = createFileRoute("/renderings")({
  head: () => ({
    meta: [
      { title: "Renderings — The Residences at Mandarin Oriental Miami" },
      { name: "description", content: "Explore the official gallery of renderings for The Residences at Mandarin Oriental, Miami." },
      { property: "og:title", content: "Renderings — The Residences at Mandarin Oriental Miami" },
      { property: "og:description", content: "Explore the official gallery of renderings for The Residences at Mandarin Oriental, Miami." },
      { property: "og:image", content: hero4.url },
      { property: "twitter:card", content: "summary_large_image" },
      { property: "twitter:image", content: hero4.url },
    ],
  }),
  component: RenderingsPage,
});

function RenderingsPage() {
  const [active, setActive] = useState<number | null>(null);

  useEffect(() => {
    if (active === null) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") setActive(null);
      if (e.key === "ArrowLeft") setActive((p) => (p === null || p === 0 ? renderings.length - 1 : p - 1));
      if (e.key === "ArrowRight") setActive((p) => (p === null || p === renderings.length - 1 ? 0 : (p ?? 0) + 1));
    };
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [active]);

  return (
    <main className="min-h-screen bg-background text-foreground">
      <div className="mx-auto max-w-[1400px] px-6 py-16 md:px-12 md:py-24">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm font-light text-muted-foreground transition hover:text-gold"
        >
          <ArrowLeft className="h-4 w-4" />
          Back to Home
        </Link>

        <div className="mt-10 text-center">
          <div className="eyebrow text-foreground/70">Gallery</div>
          <h1 className="mt-4 font-serif text-4xl leading-tight text-gold md:text-6xl">
            Renderings
          </h1>
          <div className="mx-auto mt-8 h-px w-16 bg-gold" />
          <p className="mx-auto mt-6 max-w-2xl text-base font-light text-muted-foreground md:text-lg">
            A curated collection of architectural and interior renderings for The Residences at Mandarin Oriental, Miami.
          </p>
        </div>

        <div className="mt-16 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {renderings.map((img, i) => (
            <button
              key={img.src}
              onClick={() => setActive(i)}
              className="group relative aspect-[4/3] overflow-hidden bg-muted"
            >
              <img
                src={img.src}
                alt={img.title}
                loading="lazy"
                className="h-full w-full object-cover transition duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 flex items-end bg-gradient-to-t from-black/60 via-transparent to-transparent p-4 opacity-0 transition group-hover:opacity-100">
                <span className="font-serif text-lg text-white">{img.title}</span>
              </div>
            </button>
          ))}
        </div>
      </div>

      {active !== null && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 p-4"
          onClick={() => setActive(null)}
        >
          <button
            aria-label="Close"
            onClick={() => setActive(null)}
            className="absolute top-4 right-4 z-10 flex h-11 w-11 items-center justify-center rounded-full bg-gold text-white shadow-lg transition hover:opacity-90"
          >
            <X className="h-5 w-5" />
          </button>
          <button
            aria-label="Previous"
            onClick={(e) => {
              e.stopPropagation();
              setActive((p) => (p === null || p === 0 ? renderings.length - 1 : p - 1));
            }}
            className="absolute left-4 z-10 flex h-11 w-11 items-center justify-center rounded-full bg-white/10 text-white transition hover:bg-white/20"
          >
            <ChevronLeft className="h-6 w-6" />
          </button>
          <button
            aria-label="Next"
            onClick={(e) => {
              e.stopPropagation();
              setActive((p) => (p === null || p === renderings.length - 1 ? 0 : (p ?? 0) + 1));
            }}
            className="absolute right-4 z-10 flex h-11 w-11 items-center justify-center rounded-full bg-white/10 text-white transition hover:bg-white/20"
          >
            <ChevronRight className="h-6 w-6" />
          </button>
          <img
            src={renderings[active].src}
            alt={renderings[active].title}
            onClick={(e) => e.stopPropagation()}
            className="max-h-[90vh] max-w-[90vw] object-contain"
          />
        </div>
      )}
    </main>
  );
}
